import { Component, Input, OnChanges, SimpleChanges } from '@angular/core'
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms'
import { Router } from '@angular/router'
import { ProductListItemContextSource } from '@spartacus/storefront'
import { OrderEntry } from '@spartacus/cart/base/root'
import { WishListFacade } from '@spartacus/cart/wish-list/root'
import { DataAnalyticsClickSource } from '../../../shared/mb-constants'

@Component({
  selector: 'mb-myaccount-wish-list-item',
  templateUrl: './mb-myaccount-wish-list-item.component.html',
  styleUrls: ['./mb-myaccount-wish-list-item.component.scss']
})
export class MbMyAccountWishListItemComponent implements OnChanges {

  addToCartForm = new UntypedFormGroup({
    quantity: new UntypedFormControl(1, { updateOn: 'blur' }),
  })

  dataAnalyticsClickSource = DataAnalyticsClickSource.WISHLIST

  @Input()
  wishlistEntry: any = {}

  constructor (protected productListItemContextSource: ProductListItemContextSource,
               protected router: Router,
               protected wishlistService: WishListFacade) { }

  ngOnChanges (changes?: SimpleChanges): void {
    if (changes?.wishlistEntry) {
      this.productListItemContextSource.product$.next(
        this.wishlistEntry.product
      )
    }
  }

  navigateToPdp (productCode: string) {
    return this.router.navigate(['/' + productCode])
  }

  get hasPriceOnRequest () {
    return this.wishlistEntry.product?.priceOnRequest === true
  }

  removeEntry (item: OrderEntry) {
    this.wishlistService.removeEntry(item)
  }
}
